module.exports = __webpack_public_path__ + "img/commission1.915ff589.png";